import useAdminModalProps from '../model/hooks/props/useAdminModalProps';
import useSlideModalProps from '../model/hooks/props/useSlideModalProps';
import { MODAL_TYPES } from '../constants/types';

export const modalsConfig = {
  [MODAL_TYPES.slideModal]: useSlideModalProps,
  [MODAL_TYPES.adminModal]: useAdminModalProps,
};
